/* esm.sh - markdown-table@3.0.4 */
export * from "/*markdown-table@3.0.4/esnext/markdown-table.mjs";
